// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-tjcx-xsxxcjcx-gwyXsxxcjcx-index-main_right_content-2WZ0j","table":"components-tjcx-xsxxcjcx-gwyXsxxcjcx-index-table-2NOvc"};


//////////////////
// WEBPACK FOOTER
// ./components/tjcx/xsxxcjcx/gwyXsxxcjcx/index.css
// module id = 2321
// module chunks = 0